import React, { useState } from "react";
import logo from "../assets/appnest_logo.png";
import ButtonCompo from "../component/ButtonCompo";
import { Link } from "react-router-dom";
import heroImage from "../assets/homepage-hero.webp";
import hero2Image from "../assets/homeheromobile-1.webp";
import { RiMenu3Fill } from "react-icons/ri";
import { BsBuilding } from "react-icons/bs";
import { LuUser2 } from "react-icons/lu";
import { RiCustomerService2Fill } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa6";

import {
  BottomNavigation,
  BottomNavigationAction,
  Drawer,
} from "@mui/material";

function Landing() {
  const [open, setOpen] = useState(false);
  return (
    <div className="w-full flex flex-col justify-center items-center">
      <div className="w-full flex justify-center h-[100vh] bg-blue-950 py-10">
        <header className="flex w-full justify-around items-center fixed top-0 py-3 bg-white">
          <img src={logo} className="w-[10rem]" alt="" />
          <div className="hidden md:flex items-center gap-10">
            <Link className="font-medium text-blue-700 text-[15px] uppercase" to={"https://www.appnestit.com/"} target="_blank">
              Company
            </Link>
            <ButtonCompo className="!bg-blue-500 !text-white !px-3 !py-2" href="https://wa.me/9148054805?text=Hello%21%20I%20want%20a%20demo%20of%20AppNest%20People%20ERP%20">
              <p className="text-[13px] font-medium">Schedule A Demo</p>
            </ButtonCompo>
          </div>
        </header>
        <div className="w-[60rem] items-center flex flex-col mt-[5rem]">
          <div className="text-center flex-grow">
            <p className="text-yellow-300 uppercase text-[12px] mb-5 tracking-wider font-semibold">
              Built to Make Enterprises Change-Ready
            </p>
            <h1 className="text-[25px] md:text-[40px] text-white font-extrabold">
              APPNEST PEOPLE CRM
            </h1>
            <span className="text-[20px] md:text-[50px] text-white">
              for the Evolving World of Work
            </span>
            <p className="text-slate-300 mt-5 text-[12px] md:text-[17px] px-2">
              Our HR software streamlines employee management, from recruitment
              to performance tracking, in one easy-to-use platform. With
              automated workflows and real-time analytics, it helps businesses
              optimize their HR processes and improve workforce efficiency.
            </p>
            <div className="w-full hidden md:flex justify-center items-center gap-5 mt-5 md:mt-10">
              <ButtonCompo
                className="!bg-blue-500 hover:!bg-blue-600 !text-white !w-[7rem] !h-[2.5rem]"
                href="/company/signup"
              >
                Company
              </ButtonCompo>
              <ButtonCompo
                className="!text-white hover:!bg-slate-100/30 !w-[7rem] !h-[2.5rem] !bg-slate-100/10"
                href="/employee/signin"
              >
                Employee
              </ButtonCompo>
            </div>
          </div>
          <img
            src={heroImage}
            className="w-[80rem] hidden md:block mt-10 transform"
            alt=""
          />
          <img
            src={hero2Image}
            className="w-[80rem] block md:hidden mt-5 md:mt-10"
            alt=""
          />
          <div className="fixed bottom-0 block md:hidden w-full bg-white shadow-lg">
            <BottomNavigation showLabels>
              <BottomNavigationAction
                href="/company/signup"
                label="Company"
                icon={<BsBuilding />}
              />
              <BottomNavigationAction
                label="Employee"
                icon={<LuUser2 />}
                href="/employee/signin"
              />
              <BottomNavigationAction
                label="Help"
                icon={<RiCustomerService2Fill />}
                href="https://wa.me/9148054805?text=Hello%21%20I%20need%20a%20help%20"
              />
              <BottomNavigationAction
                label="Demo"
                icon={<FaWhatsapp />}
                href="https://wa.me/9148054805?text=Hello%21%20I%20want%20a%20demo%20of%20AppNest%20People%20ERP%20"
              />
            </BottomNavigation>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
